import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/ru';

import { inflect } from '@/utils/format';
import dayjs from 'dayjs';

dayjs.extend(updateLocale)

dayjs.updateLocale('ru', {
  relativeTime: {
    future: "%s", // через
    past: "%s назад", // назад
    s: 'менее минуты',
    m: "около минуты",
    mm: (m: number) => `${m} минут${inflect(m, 'а', 'ы')}`,
    h: "около часа",
    hh: (h: number) => `${h} час${inflect(h, '', 'а', 'ов')}`,
    d: "около дня",
    dd: (d: number) => `${d} ${inflect(d, 'день', 'дня', 'дней')}`,
    M: "около месяца",
    MM: (m: number) => `${m} месяц${inflect(m, '', 'а', 'ев')}`,
    y: "около года",
    yy: (y: number) => `${y} ${inflect(y, 'год', 'года', 'лет')}`,
  }
});

dayjs.extend(relativeTime);

export default dayjs;